import React from 'react';
import { styled } from '@nykaa/ui-components';
import { NEW_TAG_CLASS, OLD_TAG_CLASS } from '../constants';
import { generateId } from '../helper';
const Wrapper = styled.li `
  font-size: 8px;
  margin-right: 4px;
  border: none;
  display: inline-block;
  padding: 0 5px;
  text-transform: uppercase;
  &.custom-tag {
    padding: 3px 5px;
    background-color: ${({ customStyle }) => customStyle === null || customStyle === void 0 ? void 0 : customStyle.bgColor};
    border: ${({ customStyle }) => (customStyle === null || customStyle === void 0 ? void 0 : customStyle.borderColor) && `1px solid ${customStyle.borderColor}`};
    color: ${({ customStyle }) => customStyle === null || customStyle === void 0 ? void 0 : customStyle.titleColor};
    font-weight: ${({ customStyle }) => customStyle === null || customStyle === void 0 ? void 0 : customStyle.fontWeight};
    opacity: ${({ customStyle }) => customStyle === null || customStyle === void 0 ? void 0 : customStyle.opacity};
    font-size: ${({ customStyle }) => customStyle === null || customStyle === void 0 ? void 0 : customStyle.fontSize};
  }

  &.default-tag {
    line-height: 13px;
  }
  &.featured {
    background-color: #ffeed7;
    border: 1px solid #ffe4c0;
    color: #fea838;
  }

  &.offer {
    background-color: #ffeed7;
    border: 1px solid #ffe4c0;
    color: #fea838;
  }

  &.new {
    background-color: #e6f8ff;
    border: 1px solid #cee9f3;
    color: #6dcff6;
  }

  &.bestseller {
    background-color: #dff9e5;
    border: 1px solid #c3e7ce;
    color: #68a677;
  }
`;
const OFFER = 'offer';
const OFFERS = 'offers';
const TagName = ({ index, tag = '', handleTagClick, offersCount, showMultipleTag, customStyle, }) => {
    let updatedTagObj = tag;
    if (typeof tag === 'string') {
        updatedTagObj = {
            name: tag || '',
            id: generateId(tag),
        };
    }
    else if (updatedTagObj === null || !updatedTagObj.name) {
        return null;
    }
    const { name = '', id = '' } = updatedTagObj;
    let updatedName = name;
    if (updatedName === OFFER) {
        if (offersCount > 1) {
            updatedName = OFFERS;
        }
    }
    const listKey = `tagItem${index}`;
    const tagClass = (showMultipleTag && Object.keys(customStyle).length)
        ? NEW_TAG_CLASS
        : `${id === null || id === void 0 ? void 0 : id.toLowerCase()} ${OLD_TAG_CLASS}`;
    return (React.createElement(Wrapper, { tabIndex: 0, role: "button", onClick: () => handleTagClick((updatedName === null || updatedName === void 0 ? void 0 : updatedName.toLowerCase()) || updatedName), key: listKey, className: tagClass, customStyle: customStyle }, updatedName));
};
export default TagName;
